import { Controller } from "@hotwired/stimulus"
import $ from "jquery";

export default class extends Controller {
    // workaround to type readonly element
    // this will return the element that was detected as controller

    get el() {
        return this.element;
    }

    connect() {
    }

    onSubmit(event) {
        //event.preventDefault();
        console.log("submit")
    }
}

